export const helloCore = (name: string): string => {
  return `Hello ${name} from PetSure Payment Core`;
}